<template>
  <div class="footer" id="footer">
    <div class="footer__wrapper">
      <div class="footer__col footer__col-one">
        <div class="footer__left">
          <div class="footer__left__inner">
            <div class="stages-footer-title-bottom">Выберите страну</div>
<Select />
            <div class="content">
              <div class="content__text">
                <span v-if="distance === '> 4500 км'">Ух, как далеко! </span>
                <span v-if="distance === '> 4500 км'" :style="$browserDetect.isIE ? 'max-width: 600px' : ''">Не так важно, насколько далеко находится выбранная вами точка. Важно, что вы можете выиграть путешествие в эту страну!</span>
                <span v-else>Расстояние</span>
                <span class="content__text__size" v-if="distance === '> 4500 км'">∞</span>
<!--                <span class="content__text__size" v-else>{{ distance }}</span>-->
                <span class="content__text__size" v-else>-</span>
              </div>
              <div class="footer__left__image">
                <img class="footer__left__image__svg" :src="`/ru/lg-travel/images/desktop/map/countries/${selectedCountry}.svg`" alt="map">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer__col">
        <div class="footer__right">
          <div class="footer__right__title">Оставьте информацию о себе</div>
          <form class="footer__right__input" @submit.prevent>
            <Input
                v-for="item in content.inputs"
                :key="item.name"
                :placeholder="item.placeholder"
                :name="item.name"
                @setName="body.name = $event"
                @setEmail="body.email = $event"
                @setNumber="body.number = $event"
            />
          </form>
          <div v-if="date" class="footer__social">
            <div class="footer__social__text">или</div>
            <a class="footer__social__svg" href="https://lg-travel.24ttl.net/api/auth/ok">
              <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="22" cy="22" r="22" fill="#333333"/>
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M26.5367 21.898C26.4081 19.4353 24.5508 17.9542 22.3083 17.9542H22.2235C19.6355 17.9542 18.2001 19.9578 18.2001 22.2337C18.2001 24.7817 19.9366 26.3916 22.2136 26.3916C24.7522 26.3916 26.4214 24.5611 26.5424 22.3954L26.5367 21.898ZM22.2363 15.7505C23.9657 15.7505 25.5919 16.5029 26.7854 17.6812V17.6857C26.7854 17.1201 27.1721 16.6936 27.7091 16.6936L27.8448 16.6929C28.6844 16.6929 28.8569 17.4746 28.8569 17.7224L28.8611 26.5168C28.8018 27.0927 29.4645 27.39 29.8321 27.0204C31.2668 25.5693 32.9827 19.5602 28.9403 16.0785C25.1727 12.8325 20.1175 13.3673 17.429 15.1917C14.5711 17.1319 12.7422 21.4267 14.5189 25.4606C16.4553 29.8603 21.9967 31.1724 25.29 29.863C26.9579 29.2009 27.7281 31.4199 25.996 32.1448C23.379 33.2421 16.0948 33.1314 12.6919 27.3292C10.393 23.4112 10.5152 16.5179 16.6129 12.9463C21.2772 10.2136 27.4272 10.9697 31.1354 14.7823C35.0117 18.7682 34.7855 26.2315 31.0045 29.1326C29.2916 30.4508 26.7474 29.1681 26.7634 27.2471L26.7458 26.6191C25.5529 27.7843 23.9657 28.4642 22.2363 28.4642C18.8193 28.4642 15.8129 25.5052 15.8129 22.1416C15.8129 18.7446 18.8193 15.7505 22.2363 15.7505Z"
                      fill="white"/>
              </svg>
            </a>
            <a class="footer__social__svg" href="https://lg-travel.24ttl.net/api/auth/google">
              <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="22" cy="22" r="22" fill="#333333"/>
                <path
                    d="M22.438 23.5069V20.4155H32.5362C32.6349 20.9543 32.6859 21.5916 32.6859 22.2815C32.6859 24.6009 32.0713 27.4689 30.0905 29.5123C28.1638 31.582 25.7022 32.6858 22.4412 32.6858C16.397 32.6858 11.3145 27.6069 11.3145 21.3715C11.3145 15.1362 16.397 10.0573 22.4412 10.0573C25.785 10.0573 28.167 11.4108 29.9567 13.1749L27.8422 15.3563C26.5588 14.1145 24.8201 13.1486 22.438 13.1486C18.0243 13.1486 14.5722 16.8182 14.5722 21.3715C14.5722 25.9248 18.0243 29.5944 22.438 29.5944C25.3009 29.5944 26.9314 28.4085 27.976 27.3309C28.823 26.4571 29.3803 25.2087 29.6001 23.5036L22.438 23.5069Z"
                    fill="white"/>
              </svg>
            </a>
            <a class="footer__social__svg" href="https://lg-travel.24ttl.net/api/auth/vkontakte">
              <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0)">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M22 43.9981C9.84971 43.9981 0 34.1483 0 21.9981C0 9.84776 9.84971 -0.00195312 22 -0.00195312C34.1503 -0.00195312 44 9.84776 44 21.9981C44 34.1483 34.1503 43.9981 22 43.9981ZM31.939 20.5863C33.4827 18.7974 34.1 17.7062 33.9077 17.2385C33.7229 16.7922 32.5877 16.9104 32.5877 16.9104L28.8074 16.9318C28.8074 16.9318 28.5271 16.8978 28.3197 17.0059C28.116 17.1115 27.9853 17.3579 27.9853 17.3579C27.9853 17.3579 27.3869 18.7421 26.5898 19.9187C24.9065 22.4029 24.2339 22.5336 23.9586 22.3802C23.3187 22.0207 23.4784 20.9358 23.4784 20.1651C23.4784 17.759 23.8983 16.7545 22.66 16.4955C22.2489 16.4088 21.9472 16.3132 20.8962 16.3032C19.5473 16.2919 18.4058 16.3459 17.7597 16.6212C17.3297 16.8048 16.9978 17.2121 17.199 17.236C17.4491 17.2649 18.0149 17.368 18.3153 17.7238C18.7025 18.1814 18.6887 19.2097 18.6887 19.2097C18.6887 19.2097 18.9112 22.0433 18.1695 22.3953C17.6591 22.6367 16.9601 22.1426 15.4603 19.8898C14.691 18.7358 14.1102 17.461 14.1102 17.461C14.1102 17.461 13.9983 17.2222 13.7997 17.0952C13.557 16.9406 13.2176 16.8903 13.2176 16.8903L9.62594 16.9116C9.62594 16.9116 9.08663 16.9242 8.88926 17.1279C8.71326 17.3089 8.87543 17.6835 8.87543 17.6835C8.87543 17.6835 11.6877 23.401 14.8707 26.2811C17.7911 28.9224 21.3714 28.9136 21.3714 28.9136H22.6286C22.6286 28.9136 23.0635 28.7062 23.2949 28.4887C23.5086 28.2901 23.501 27.9154 23.501 27.9154C23.501 27.9154 23.4721 26.163 24.4074 25.9053C25.3302 25.6513 26.5144 27.5986 27.7703 28.3479C28.7194 28.9136 29.441 28.9086 29.441 28.9086L32.7989 28.9061C32.7989 28.9061 34.5551 28.6559 33.7216 27.4553C33.6537 27.3573 33.2376 26.5678 31.2262 24.9461C29.1205 23.2489 29.4021 23.523 31.939 20.5863Z"
                        fill="#333333"/>
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="44" height="44" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </a>
            <a class="footer__social__svg" href="https://lg-travel.24ttl.net/api/auth/yandex">
              <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="22" cy="22" r="22" fill="#333333"/>
                <path
                    d="M23.9738 23.6241H22.6501C20.5701 23.6241 18.5531 22.1761 18.5531 18.5552C18.5531 14.784 20.4442 13.2452 22.3664 13.2452H23.9738V23.6241ZM26.0538 11.3142H22.4613C18.9308 11.3142 15.9376 13.8792 15.9376 18.8573C15.9376 21.8442 17.3872 24.0468 19.9716 25.1324L15.1494 33.4598C14.9916 33.7314 15.1494 33.9427 15.4012 33.9427H17.639C17.8278 33.9427 17.9546 33.8825 18.0176 33.7314L22.3983 25.5551H23.9738V33.7314C23.9738 33.8222 24.0687 33.9427 24.1946 33.9427H26.1487C26.3375 33.9427 26.4005 33.8519 26.4005 33.7017V11.6155C26.4005 11.405 26.2746 11.3142 26.0538 11.3142Z"
                    fill="white"/>
              </svg>
            </a>
            <a class="footer__social__svg" href="https://lg-travel.24ttl.net/api/auth/facebook">
              <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0)">
                  <circle cx="22" cy="22" r="22" fill="white"/>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M22 44C17.6488 44 13.3952 42.7097 9.77734 40.2923C6.15946 37.875 3.33979 34.439 1.67466 30.419C0.00953126 26.3991 -0.426141 21.9756 0.422734 17.708C1.27161 13.4404 3.36682 9.52041 6.44358 6.44365C9.52033 3.3669 13.4404 1.27161 17.708 0.422734C21.9756 -0.426141 26.3989 0.00953126 30.4189 1.67466C34.4389 3.33979 37.8748 6.15959 40.2922 9.77747C42.7096 13.3954 44 17.6488 44 22C44 27.8348 41.6821 33.4306 37.5563 37.5564C33.4305 41.6822 27.8347 44 22 44ZM26.6765 21.2947L27.0663 17.5108H23.7348V15.2818C23.7161 15.1496 23.7268 15.0149 23.7663 14.8874C23.8057 14.7598 23.873 14.6426 23.9632 14.544C24.0533 14.4455 24.164 14.3681 24.2876 14.3175C24.4111 14.2668 24.5443 14.2441 24.6777 14.251H27.0789V10.5726L23.7726 10.56C23.1704 10.5128 22.5651 10.5968 21.9986 10.8062C21.432 11.0156 20.9177 11.3454 20.491 11.7729C20.0643 12.2005 19.7356 12.7154 19.5273 13.2824C19.319 13.8493 19.2361 14.4548 19.2845 15.0568V17.5082H17.16V21.2947H19.2845V32.071H23.7348V21.2947H26.6765Z"
                        fill="#333333"/>
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="44" height="44" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </a>
            <a class="footer__social__svg" href="">
              <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0)">
                  <circle cx="22" cy="22" r="22" fill="white"/>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M22 43.9981C9.84971 43.9981 0 34.1483 0 21.9981C0 9.84776 9.84971 -0.00195312 22 -0.00195312C34.1503 -0.00195312 44 9.84776 44 21.9981C44 34.1483 34.1503 43.9981 22 43.9981ZM27.3718 23.0867C26.6037 23.0867 25.0699 24.535 22 24.535C18.9301 24.535 17.3951 23.0867 16.6282 23.0867C15.7847 23.0867 15.0933 23.7379 15.0933 24.535C15.0933 25.2591 15.5534 25.6211 15.8614 25.767C16.7816 26.2736 19.6982 27.4314 19.6982 27.4314L16.3982 31.3437C16.3982 31.3437 15.7847 31.9949 15.7847 32.5027C15.7847 33.2985 16.4749 33.951 17.3184 33.951C18.0865 33.951 18.4699 33.4443 18.4699 33.4443L22 29.605L25.4534 33.4443C25.4534 33.4443 25.8368 33.951 26.6037 33.951C27.4485 33.951 28.1386 33.2985 28.1386 32.5027C28.1386 32.0678 27.5251 31.3437 27.5251 31.3437L24.3018 27.4314C24.3018 27.4314 27.2184 26.2736 28.1386 25.767C28.4466 25.5482 28.9067 25.2591 28.9067 24.535C28.9067 23.7379 28.2153 23.0867 27.3718 23.0867ZM22 10.0489C25.2271 10.0489 27.8432 12.7254 27.8432 16.0241C27.8432 19.3241 25.2271 22.0006 22 22.0006C18.7729 22.0006 16.1555 19.3241 16.1555 16.0241C16.1555 12.7254 18.7729 10.0489 22 10.0489ZM22 12.7656C23.76 12.7656 25.1881 14.2239 25.1881 16.0241C25.1881 17.8243 23.76 19.2839 22 19.2839C20.24 19.2839 18.8119 17.8243 18.8119 16.0241C18.8119 14.2239 20.24 12.7656 22 12.7656Z"
                        fill="#333333"/>
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="44" height="44" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
          <div class="footer__agreement">
            <div v-if="date" class="form-group">
              <input type="checkbox" id="policy1" v-model="policy1">
              <label for="policy1">
      <span class="form-group-text">
        Я даю свое согласие на обработку, хранение, передачу, в том числе трансграничную передачу, моих персональных данных с целью участия в настоящей акции и соглашаюсь с <a
          target="_blank" class="footer__red" href="https://rushop.lg.com/page/privacy">Политикой конфиденциальности</a> и <a
          target="_blank" class="footer__red" href="https://rushop.lg.com/page/personaldata">Политикой в отношении обработки персональных данных</a>
      </span>
              </label>
            </div>
            <div v-if="date" class="form-group">
              <input type="checkbox" id="policy2" v-model="policy2">
              <label for="policy2">
      <span class="form-group-text">
                Я согласен получать рекламные и маркетинговые рассылки от ООО «ЛГ Электроникс РУС» и ООО «Лаборатория Инноваций»
      </span>
              </label>
            </div>
            <div v-if="date" class="form-group">
              <input type="checkbox" id="policy3" v-model="policy3">
              <label for="policy3">
      <span class="form-group-text">
        Я принимаю <a class="footer__red" href="#" @click.prevent="openModal">Условия акции</a>
      </span>
              </label>
            </div>
            <div v-if="!date" class="old"> Прием заявок завершен. Следите за результатами розыгрыша на сайте.</div>
            <Button v-if="date"  :footer="true" :content="btn"  @sendForm="sendForm" />
            <a v-if="!date" style="opacity: 0.4;cursor: default;background-color: #A50034" class="btn btn-footer">
              <span>Хочу в путешествие</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Input from "../elements/input/input";
import Button from "../elements/button/Button";
import Select from "../elements/select/Select";
import {bus} from "../../utils/bus";
import {mapState} from "vuex";

export default {
  name: "Footer",
  props: ["content"],
  components: {Button, Input,Select},
  data(){
    return {
      date: false,
      body: {
        name: "",
        email: "",
        number: ""
      },
      policy1: true,
      policy2: true,
      policy3: true,
      btn: {
        text: "Хочу в путешествие",
        textSecond:"Хочу узнать о скидке",
        color: "#A50034"
      }
    }
  },
  methods:{
    openModal() {
      bus.$emit('open-modal', true)
    },
    openValidModal(){
        bus.$emit('open-modal-valid', true)
    },
    validateEmail(email){
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    sendForm(){
      if(!this.policy1 && !this.policy2 && !this.policy3)
        return bus.$emit('open-modal-valid', "Пожалуйста примите условия акции !")
      if(!this.body.name)
       return bus.$emit('open-modal-valid', "Пожалуйста, заполните поле «Имя»")

      if(!this.body.number)
       return bus.$emit('open-modal-valid', "Пожалуйста, заполните поле «Мобильный телефон»")

      if(!this.body.email)
      return bus.$emit('open-modal-valid', "Пожалуйста, заполните поле «Email»")

      if(!this.validateEmail(this.body.email))
        return bus.$emit('open-modal-valid', "Пожалуйста, введите корректный адрес электронной почты. Адрес электронной почты заполняется латинскими буквами и должен содержать значки «@» и «.».")

      const body = {
        name: this.body.name,
        email: this.body.email,
        number: this.body.number,
        country: this.selectedCountry
      }
this.$store.dispatch('sendForm',body).then(()=>{
  bus.$emit('thank-open-modal' +
      '' +
      '', true)
  this.$gtm.trackEvent({
    event: 'lgcompromo',
    category: 'promo_map',
    eventCategory: 'promo_map',
    action: 'form',
    eventAction: 'form',
    label: this.selectedCountry,
    eventLabel: this.selectedCountry,
    noninteraction: false // Optional
  });
}).catch((e)=>{
  if(e.response.status === 302)
  return bus.$emit('open-modal-valid', "Данная почта уже зарегистрирована")
  if(e.response.status === 404)
    return bus.$emit('open-modal-valid', "Данный мобильный номер уже зарегистрирован")
})
      return null
    }
  },
  computed: {
    ...mapState({
      selectedCountry: "selectedCountry",
      distance: "distance"
    })
  },
  mounted() {
    // const isToday = (date) => {
    //   const today = new Date()
    //   return date.getDate() === today.getDate() &&
    //       date.getMonth() === today.getMonth() &&
    //       date.getFullYear() === today.getFullYear();
    // }
    // const date = new Date(2021, 7, 1);
    //
    // if (isToday(date)) {
    //   this.date = false
    // }
    // console.log(isToday(date)); // true
  }
}
</script>

<style lang="scss">
@import "foooter";
@import "../elements/input/input";
@import "../elements/checbox/checkbox.scss";
</style>